import React, { createContext, useContext } from "react";
import type { ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import type { CurrentUserFull } from "@/types/index";

interface UserContextValue {
  currentUser: CurrentUserFull | undefined;
  isLoadingUser: boolean;
}

export const UserContext = createContext<UserContextValue | undefined>(undefined);

export function UserProvider({ children }: { children: ReactNode }) {
  const { data: currentUser, isLoading: isLoadingUser } = useQuery<CurrentUserFull>({
    queryKey: ["currentUser"],
    queryFn: async () => {
      const response = await fetch("/api/me");
      if (!response.ok) {
        throw new Error("Failed to fetch current user");
      }
      return response.json() as Promise<CurrentUserFull>;
    },
  });
  return (
    <UserContext.Provider value={{ currentUser, isLoadingUser }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
}
